import { DcSccBaseModel } from 'dc-scc'
import { V1 as StoreV1 } from '../Stores/V1';

export class V1 extends DcSccBaseModel
{
	protected _guid=null;
	protected _wsIp=null;
	protected _wsPort=null;
	protected _wsSsl=null;
	protected _wrkObj=null;
	protected _isReconn=false;

	public setConfig(ip, port, ssl=true)
	{
		this._wsIp		= ip;
		this._wsPort	= port;
		this._wsSsl		= ssl;
		this._guid		= this.getMtm().get("utilities").getGuids().getV4().get(false);
		return this;
	}
	public async getPublicStore(id, auth)
	{
		var storeObj	= this.getService().getStores().getV1(id, auth, this);
		return await storeObj.initialize();
	}
	public getGuid()
	{
		return this._guid;
	}
	public getPublicWorker()
	{
		return this._wrkObj;
	}
	public async initialize()
	{
		if (this.isInit() === false) {
			
			this._wrkObj	= this.getService().getDcScc().getWorkers().getV3(this._wsIp, this._wsPort, this._wsSsl);
			this._wrkObj.initialize();
			
			//authenticate with DDS using an EAS emphemeral key
			var ephKey	= await this.getMtm().get("DcEasApi").getEphemeralKeys().newReadUserPublic();
			var cObj	= this._wrkObj.getClient();
			var reqObj	= cObj.newMessage();
			reqObj.setL1("Authentication").setL2("Get").setL3("Salt");
			var salt	= await reqObj.getResponse(true);
			
			var reqObj	= cObj.newMessage();
			reqObj.setL1("Authentication").setL2("Validate").setL3("ByEAS").setL4("EphemeralKey");
			var hash	= await this.getMtm().get("utilities").getHashing().getSHA().get256("DDS--"+salt);
			await ephKey.signRequest(reqObj, hash);
			
			var sessObj		= await reqObj.getResponse(true);
			if (
				typeof sessObj["session-id"] != "undefined"
				&& typeof sessObj["session-key"] != "undefined"
			) {
				cObj.setSession(sessObj["session-id"], sessObj["session-key"]);
			} else {
				await reqObj.getResponse(true);
			}
			
			this._wrkObj.setIngressCb(this.getService().getHandlers(), "handle");
			this._wrkObj.setTermCb(this, "reconnect");
			this.setInit();
		}
		return this;
	}
	public async reconnect(wrkObj)
	{	
		if (this._isReconn === false) {
			this._isReconn	= true;
			this.logInfo("DDS Reconnecting");
			try {
				
				try {
					
					this._wrkObj	= null;
					this.unInit();
					await this.initialize();
					this._isReconn	= false;
					this.logInfo("DDS Reconnect success");
					
					var storeObjs	= this.getService().getStores().getByClient(this);
					for (let storeObj of storeObjs) {
						await storeObj.unInit().initialize();
					}
					this.logInfo("DDS API reloaded: "+storeObjs.length+" stores");
					
				} catch (errObj) {
					throw this.getService().getMtm().newException("DDS Reconnect failed");
				}
				
			} catch (errObj) {
				this._isReconn	= false;
				this.callException(errObj);
			}
		}
	}
	public async newRequest()
	{
		var cObj	= await this.getPublicWorker().getClient().isAuth();
		return cObj.newMessage();
	}
}